import { VolumeUnit } from "@/models/meterReadEstimate/meterReadEstimate.types"

/**
 * The pinned option at the top of every read dropdown. Nothing is selected to
 * begin with - the placeholder invites either action, rather than the form
 * arriving having already assumed the agent will type.
 */
export const USER_INPUT = "USER_INPUT"

export const READ_PLACEHOLDER = "Select or input a read"

export interface IRegisterFormState {
  registerId: number
  read1Id: string | null
  read1Value: number | null
  read1Date: Date | null
  read2Id: string | null
  read2Value: number | null
  read2Date: Date | null
  eacAq: number | null
  /** Null until we know it - never assumed. See SO-32714. */
  unit: VolumeUnit | null
}

export type RegisterFormPatch = Partial<Omit<IRegisterFormState, "registerId">>
